/* Package JSON Import will be here */
import React from "react";
import { Button, Row, Col, Divider, Badge } from "antd";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
import classNames from "classnames";
import { forEach, includes } from "lodash";
/* Package JSON Import will be here */

/* Project Import will be here */
import { ButtonSpinner } from "components/Spinner";
import { getOrderVolumeByConversionRate, getCultureNumberFormat } from "utilities/utils";
/* Project Import will be here */

const ProductValue = (props) => {
    const { cart, orders, translate, appSettings } = useSelector((state) => ({
        cart: state.cart,
        orders: state.orders,
        translate: getTranslate(state.locale),
        appSettings: state.appSettings
    }));

    let totalGrossAmount = 0;
    let totalLineCount = cart.freeProducts.length;
    let totalOrderVolume = 0;

    for (let key in cart.data) {
        const cartProduct = cart.data[key];

        /* Check for the product override in smart list */
        if (props.isFromSmartList && includes(props.selectedCheckBoxProducts, parseInt(key, 10)))
            continue;
        else if (props.isFromSmartList && !includes(cart.ids, parseInt(key, 10)))
            continue;

        /* Check for line count */
        if (cartProduct.pieceQTY > 0 || cartProduct.caseQTY > 0)
            totalLineCount += 1

        /* TODO: Need to check this !conversionQTY condition */
        if (!cartProduct.ConversionQty) {
            const orderProduct = orders.data[key];
            let qty = 0;
            let price = 0;
            let weight = 0

            const orderProductCartInfo = orderProduct.productInfo;
            if (orderProduct) {
                if (props.isFromSmartList)
                    qty = cartProduct.Qty
                if (cartProduct.caseQTY && !cartProduct.pieceQTY)
                    qty = cartProduct.caseQTY * orderProductCartInfo.ConversionQty
                else if (!cartProduct.caseQTY && cartProduct.pieceQTY)
                    qty = cartProduct.pieceQTY
                else
                    qty = (cartProduct.caseQTY * orderProductCartInfo.ConversionQty) + cartProduct.pieceQTY

                price = orderProductCartInfo.SellPrice * qty;
                weight = orderProductCartInfo.Weight * qty;
            }

            if (price > 0)
                totalGrossAmount += price;

            totalOrderVolume += isNaN(weight) ? 0 : weight;
        }
        else {
            let qty = 0
            if (props.isFromSmartList)
                qty = cartProduct.Qty
            else
                qty = (cartProduct.caseQTY * cartProduct.ConversionQty) + cartProduct.pieceQTY;

            const priceWithTax = cartProduct.Price * qty;

            totalGrossAmount += priceWithTax;
            totalOrderVolume += cartProduct.Weight * qty;
        }
    }

    /* Check for smart list products */
    if (props.isFromSmartList) {
        forEach(props.smartListProducts, o => {
            if (includes(props.selectedCheckBoxProducts, o.ProductId)) {
                /* check the added qty of the product from order reducer */
                const orderSmartListProduct = orders.data[o.ProductId];
                if (orderSmartListProduct !== null && orderSmartListProduct !== undefined) {
                    let effectiveSmartListSum = 0;

                    /* Piece count */
                    effectiveSmartListSum = effectiveSmartListSum + (orderSmartListProduct.count * o.SellPrice);

                    /* Check for case count */
                    if (orderSmartListProduct.case_count > 0)
                        effectiveSmartListSum = effectiveSmartListSum + ((orderSmartListProduct.case_count * o.ConversionQty) * o.SellPrice);

                    totalGrossAmount += effectiveSmartListSum;

                    if (orderSmartListProduct.count > 0 || orderSmartListProduct.case_count > 0)
                        totalLineCount += 1;
                }
            }
        });
    }

    return (
        <React.Fragment>
            <div className="product-order-value-box">
                <Row className="w-100">
                    <Col span={appSettings.isEnableOrderVolume ? 14 : 12} md={appSettings.isEnableOrderVolume ? 16 : 12}>
                        <Row className="w-100">
                            <Col span={24} md={appSettings.isEnableOrderVolume ? 11 : 24}
                                className={classNames('font-bold product-value-footer text-center', {
                                    'mt-11-px': !appSettings.isEnableOrderVolume
                                })}
                            >
                                {`${translate("products.productLabel.ogv")} : ${getCultureNumberFormat(totalGrossAmount.toFixed(2), true)}`}
                            </Col>
                            {appSettings.isEnableOrderVolume &&
                                <React.Fragment>
                                    <Col span={0} md={2}>
                                        <Divider className="h-100" type="vertical" />
                                    </Col>
                                    <Col span={24} md={11}
                                        className={classNames('font-bold product-value-footer text-center', {
                                            'mt-11-px': !appSettings.isEnableOrderVolume
                                        })}
                                    >
                                        {`${translate("products.productLabel.orderVol")} : ${getOrderVolumeByConversionRate(appSettings, totalOrderVolume)}`}
                                    </Col>
                                </React.Fragment>
                            }
                        </Row>
                    </Col>
                    <Col span={1}>
                        <Divider className="h-100" type="vertical" />
                    </Col>
                    <Col span={appSettings.isEnableOrderVolume ? 9 : 11} md={appSettings.isEnableOrderVolume ? 7 : 11} className="text-center special-class-for-badge">
                        <Badge count={totalLineCount} title={' '} overflowCount={99}>
                            <Button
                                type="primary"
                                shape="round"
                                className='p-value-add-to-cart-btn'
                                onClick={props.orderSubmit}
                                disabled={orders.isLoading || cart.isLoading || !cart.isCartInitiated}
                                size="large"
                            >
                                <div className={`${(orders.isLoading || cart.isLoading || !cart.isCartInitiated) && 'modify-font-size'}`} style={{ display: 'inline-block' }}>{translate(cart.ids.length > 0 ? "common.buttons.updateCart" : "common.buttons.addToCart")}</div>
                                {(orders.isLoading || cart.isLoading || !cart.isCartInitiated) && <ButtonSpinner />}
                            </Button>
                        </Badge>
                    </Col>
                </Row>
            </div>
        </React.Fragment>

    );
};

export default ProductValue;